// src/api/cookieUtil.ts
//
// Tiny cookie reader shared by safeFetch and authClient. Was duplicated
// inside authClient.ts; lifted here so safeFetch can inject the CSRF
// token without importing the auth client (which would re-introduce the
// historical circular import the 401 contract was designed to avoid).

/** Read a cookie by name. Returns '' when not set. */
export function readCookie(name: string): string {
  const prefix = `${name}=`;
  for (const part of document.cookie.split(';')) {
    const t = part.trim();
    if (t.startsWith(prefix)) {
      return decodeURIComponent(t.slice(prefix.length));
    }
  }
  return '';
}
